import { ValidatorFn, Validators } from '@angular/forms';

export function emailValidator(): ValidatorFn {
  return (control) => {
    const email = control.value;

    if (email === '') {
      return null; // l'indirizzo email è vuoto e non viene validato
    }

    const valid = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email);

    if (valid) {
      return null; // l'indirizzo email è valido
    } else {
      return {'email': true}; // l'indirizzo email non è valido
    }
  };
}